import {
  EMPLOYEES_REQUEST, EMPLOYEES_SUCCESS,
  EMPLOYEES_STATUS_REQUEST, EMPLOYEES_STATUS_SUCCESS,
  USER_STATUS_REQUEST, USER_STATUS_SUCCESS, EMPLOYEE_EXPAND,
  EMPLOYEES_ADMIN_STATUS_SUCCESS, EMPLOYEES_ADMIN_STATUS_REQUEST,
  ENTITIES_ASSIGN_SAVED, ENTITIES_ASSIGN_SAVING,
  POPUP_ASSIGN_ENTITY_SAVING, POPUP_ASSIGN_ENTITY_SAVED,
  FABRICATORS_REQUEST
} from '../../constants/actionTypes';

const initialState = {
  data: {
    errors: [],
    page: 0,
    pageSize: 50,
    rows: [],
    totalPages: 0
  },
  loading: false,
  searchKeyword: '',
  statusUpdateSuccess: false,
  expandedEmployeeId: 0
};

const expandEmployee = (state, employeeId) => {
  if (state.expandedEmployeeId === employeeId) {
    employeeId = 0; // collapse
  }

  return {...state, expandedEmployeeId: employeeId};
};

export default function employees(state = initialState, action) {
  switch (action.type) {
    case EMPLOYEES_REQUEST:
    case FABRICATORS_REQUEST:
      return {
        ...state,
        searchKeyword: action.searchKeyword,
        loading: true,
        statusUpdateSuccess: false
      };
    case EMPLOYEES_STATUS_REQUEST:
    case USER_STATUS_REQUEST:
    case EMPLOYEES_ADMIN_STATUS_REQUEST:
    case ENTITIES_ASSIGN_SAVING:
    case POPUP_ASSIGN_ENTITY_SAVING:
      return {
        ...state,
        loading: false,
        statusUpdateSuccess: false
      };
    case EMPLOYEES_SUCCESS:
      return {
        ...state,
        data: action.data,
        statusUpdateSuccess: false,
        loading: false
      };
    case EMPLOYEES_STATUS_SUCCESS:
    case USER_STATUS_SUCCESS:
    case EMPLOYEES_ADMIN_STATUS_SUCCESS:
    case ENTITIES_ASSIGN_SAVED:
    case POPUP_ASSIGN_ENTITY_SAVED:
      return {...state, statusUpdateSuccess: true};
    case EMPLOYEE_EXPAND:
      return expandEmployee(state, action.payload);
    default:
      return state;
  }
}
